import React, { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthPage from './AuthPage';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean; // 是否需要认证，默认true
  fallback?: ReactNode; // 未认证时的备用组件
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true,
  fallback 
}) => {
  const { isAuthenticated, loading } = useAuth();

  // 加载中状态
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">正在验证身份...</p>
        </div>
      </div>
    );
  }

  // 如果不需要认证，直接显示子组件
  if (!requireAuth) {
    return <>{children}</>;
  }

  // 如果需要认证但未登录，显示认证页面或备用组件
  if (!isAuthenticated) {
    if (fallback) {
      return <>{fallback}</>;
    }
    return <AuthPage />;
  }

  // 已认证，显示子组件
  return <>{children}</>;
};

export default ProtectedRoute;